import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-t border-white/5 bg-carbon py-16 sm:py-20" aria-labelledby="results-title" data-id="element-169" data-mp="28dn9x3zzwuzl">
      <div className="mx-auto max-w-5xl px-4" data-id="element-170" data-mp="2d79avywsrafk">
        <SectionHeading id="results-title" data-id="element-171" data-mp="2h81m2xp8bpeh">What educators using this teacher ready say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-172" data-mp="2m63ei98jp12m">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-2xl border border-lava/20 bg-petrol p-6 shadow-lg shadow-black/30 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-173" data-mp="2r70tkcy9dezw" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-lava" aria-hidden="true" data-id="element-174" data-mp="3impn9myy0r49" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-175" data-mp="3ikmqmk3abzqk">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-176" data-mp="3dla2lw0ogmme">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-lava/40 bg-carbon text-sm font-extrabold text-lava" data-id="element-177" data-mp="38mgrubcrz9px">
                  {initials}
                </span>
                <span data-id="element-178" data-mp="8q8r1lxetnm">
                  <b className="block text-sm text-snow" data-id="element-179" data-mp="86ym72ip9k5">{name}</b>
                  <small className="text-xs text-muted" data-id="element-180" data-mp="akvmlgrcvuc">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}